// extracted by mini-css-extract-plugin
export default {"row":"wBBW7","seatInfoColumn":"ge8G9","seatInfo":"MBbli"};